export default __webpack_public_path__ + "static/Graphik-Regular-2552527e8a6fbca600020156557e5abc.otf";